import React from "react";

const EditIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33.75"
    height="29.259"
    viewBox="0 0 33.75 29.259"
  >
    <g transform="translate(-1.124 -3.375)">
      <path
        className="a"
        d="M30.3,27.661l-8.409-8.367h0L17.8,15.223h0l-.942-.935a7.934,7.934,0,0,0-1.87-8.557A8.247,8.247,0,0,0,5.78,4.12L11.13,9.45,7.4,13.17,1.92,7.84a7.988,7.988,0,0,0,1.624,9.176,8.016,8.016,0,0,0,8.585,1.863l1.012,1.005-7.4,7.4a1.2,1.2,0,0,0,.134,1.87l3.08,3.073a1.3,1.3,0,0,0,1.877,0l6.757-7.9,7.973,7.938a1.2,1.2,0,0,0,1.744,0L30.171,29.4A1.12,1.12,0,0,0,30.3,27.661Z"
      />
      <path
        className="a"
        d="M34.763,15.23l-2.426-2.4a.4.4,0,0,0-.563,0l-.26.26-1.3-1.111a2.081,2.081,0,0,0-.345-1.315,17.149,17.149,0,0,0-1.631-1.891,19.568,19.568,0,0,0-4.9-3.614,13.576,13.576,0,0,0-6.391-1.786V5.463a32.612,32.612,0,0,1,3.171,2.088c1.146.921,1.181,4.184,1.181,4.184l-2,2,3.973,3.945,2.18-2.552a3.1,3.1,0,0,1,2.123-.021l.963.935-.675.668a.39.39,0,0,0,0,.555l2.426,2.4a.4.4,0,0,0,.563,0l3.916-3.881A.4.4,0,0,0,34.763,15.23Z"
      />
    </g>
    <linearGradient id="gradient-vertical" x2="0" y2="1">
      <stop offset="0%" stopColor="var(--gradient-top)" />
      <stop offset="100%" stopColor="var(--gradient-bottom)" />
    </linearGradient>
  </svg>
);

export default EditIcon;
